/**
 * Snapmint EMI widget - cleanup shim (merchant 5504).
 *
 * Snapmint forces `stopScroll = 'true'` / `scrollProperty = 'auto'` at runtime,
 * then hard-writes an inline `overflow` on <body>/<html> instead of restoring the
 * previous value. It fires in two places:
 *   1. closing the EMI popup, and
 *   2. `snapclosePopup()` inside its patched `history.pushState` handler - so it
 *      runs on EVERY facet filter / sort change on the collection page (Dawn uses
 *      pushState there), even when no popup was ever opened.
 *
 * The result is `<body style="overflow: auto">` stuck on the page, which:
 *   - turns <body> into its own scroll container -> stray horizontal scrollbar
 *     (the one that shows up right after applying a filter), and
 *   - beats the theme's class-based scroll lock (.overflow-hidden*), because an
 *     inline style always wins over a non-!important class rule.
 *
 * This theme only ever locks scrolling via classes on <body>, never inline
 * styles, so any inline `overflow` on <body>/<html> is Snapmint's and safe to
 * drop once no Snapmint modal is on screen.
 *
 * Remove this file (and its <script> tag in layout/theme.liquid) once Snapmint
 * stops writing inline overflow on close.
 */
(function () {
  'use strict';
 
  var MODAL_SELECTORS = ['#snap-modalon_page', '#sm-pop-up-model', '#snap-pop-up-model', '.snap_popup_bg'];
 
  function snapModalVisible() {
    return MODAL_SELECTORS.some(function (sel) {
      var el = document.querySelector(sel);
      if (!el) return false;
      var cs = window.getComputedStyle(el);
      return cs.display !== 'none' && cs.visibility !== 'hidden' && el.offsetParent !== null;
    });
  }
 
  function stripInlineOverflow(el) {
    if (el && el.style && el.style.overflow && !snapModalVisible()) {
      el.style.removeProperty('overflow');
    }
  }
 
  function clean() {
    stripInlineOverflow(document.body);
    stripInlineOverflow(document.documentElement);
  }
 
  function start() {
    clean();
    var observer = new MutationObserver(clean);
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['style'] });
    if (document.body) {
      observer.observe(document.body, { attributes: true, attributeFilter: ['style'] });
    }
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();